<template>
  <img :src="path" :width="size" :height="size">
</template>

<script>
export default {
  name: 'Icon',
  props: ['name', 'size'],
  computed: {
    path () {
      return '/static/img/icons/' + this.name + '.png'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Icon.vue